module.exports = __webpack_public_path__ + "media/application/images/world-map-next-d3dc146ca66c30540dd2a4469540ba5a.svg";